import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { ViewVariant } from "@/common/ts/layout";
import { TenantRequestDto } from "@/core/api/generated/v1";

import DataGrantPaginatedList from "../../../DataGrant/ListView/DataGrantPaginatedList";

interface Props {
  tenantRequest: TenantRequestDto;
}
export default function DataGrantsTabContent({ tenantRequest }: Props) {
  return (
    <PageTabContent>
      <DataGrantPaginatedList
        defaultValues={{
          tenantRequestsMeta: {
            tenantRequestId: tenantRequest.id!,
          },
        }}
        displayProps={{
          counters: false,
          viewVariant: ViewVariant.Tab,
        }}
      />
    </PageTabContent>
  );
}
